import { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import { format, addDays, startOfWeek, isSameDay } from "date-fns";
import dayjs from "dayjs";

const DateStrip = ({
  type,
  setStartDate,
  chosenDate,
  handleChange,
  existDates,
  mealDates,
  otherRecordDates,
}) => {
  const [currentDate, setCurrentDate] = useState(
    chosenDate || dayjs(new Date()).format("YYYY-MM-DD")
  );

  const [translateX, setTranslateX] = useState(0); // State to store touch movement distance
  const today = dayjs(new Date()).format("YYYY-MM-DD");

  const typeChecker = {
    RECORD_COMPLETE: {
      bg: "bg-[#417FFF]",
      dot: "bg-[#B0CAFE]",
      text: "text-[#417FFF]",
    },
    MEAL_RECORD: {
      bg: "bg-[#417FFF]",
      dot: "bg-[#B0CAFE]",
      text: "text-[#417FFF]",
    },
    WEIGHT_RECORD: {
      bg: "bg-[#FFC700]",
      dot: "bg-[#FFF2C6]",
      text: "text-[#FFC700]",
    },
    SYMPTOM_RECORD: {
      bg: "bg-[#847CE9]",
      dot: "bg-[#C0B0FE]",
      text: "text-[#847CE9]",
    },
    MEDICATION_REMINDER: {
      bg: "bg-[#01B68B]",
      dot: "bg-[#77DCC4]",
      text: "text-[#01B68B]",
    },
    APPOINTMENT_REMINDER: {
      bg: "bg-[#51CCF3]",
      dot: "bg-[#C0F0FF]",
      text: "text-[#51CCF3]",
    },
    STEPS: {
      bg: "bg-[#FE718E]",
      dot: "bg-[#FFDBE4]",
      text: "text-[#FE718E]",
    },
  };

  const getWeekDates = (date) => {
    let week = [];
    let start = startOfWeek(new Date(date)); // Set the start of the week to Monday
    for (let i = 0; i < 7; i++) {
      week.push(format(addDays(start, i), "yyyy-MM-dd"));
    }
    return week;
  };

  const handlers = useSwipeable({
    onSwiping: (eventData) => {
      setTranslateX(eventData.deltaX); // Update touch movement distance
    },
    // onSwipedLeft: () => setCurrentDate(addDays(currentDate, 7)),
    // onSwipedRight: () => setCurrentDate(addDays(currentDate, -7)),
    // onSwipedLeft: () => {
    //   handleChange(addDays(currentWeek[6], 1));
    //   setAnimationClass("animate-slideLeft");
    // },
    onSwipedLeft: () => {
      handleChange(addDays(currentDate, 7));
      setTranslateX(0); // Reset position after swipe complete
    },
    // onSwipedRight: () => {
    //   handleChange(addDays(currentWeek[0], -7));
    //   setAnimationClass("animate-slideRight");
    // },
    onSwipedRight: () => {
      handleChange(addDays(currentDate, -7));
      setTranslateX(0); // Reset position after swipe complete
    },

    onSwiped: () => {
      setTranslateX(0); // Reset position after swipe complete, apply snap animation
    },
    preventDefaultTouchmoveEvent: true, // Prevent browser's touchmove event
    trackMouse: true,
    trackTouch: true,
  });

  const weekDates = getWeekDates(currentDate);

  useEffect(() => {
    setStartDate(currentDate);
  }, [currentDate]);

  useEffect(() => {
    if (chosenDate) {
      setCurrentDate(chosenDate);
    }
  }, [chosenDate]);

  return (
    <div className="w-full font-semibold leading-tight text-white">
      <div className="flex items-center justify-between w-full mx-auto mb-1 text-sm font-semibold">
        {["S", "M", "T", "W", "T", "F", "S"].map((val, index) => (
          <p
            className={`h-[25px] w-[45px] self-center text-center leading-[25px]`}
            key={index}
          >
            {val}
          </p>
        ))}
      </div>
      <div
        {...handlers}
        className={` flex items-center justify-between text-lg first-letter:mt-[10px] `}
        style={{
          transform: `translateX(${translateX}px)`,
          transition: "transform 0.2s ease-out",
        }}
      >
        {weekDates.map((date, index) => (
          <div
            key={index}
            className={"h-[44px] text-center text-white"}
            onClick={() => {
              handleChange(date);
            }}
          >
            <p
              className={` ${
                date === chosenDate
                  ? `bg-white ${typeChecker[type]?.text}`
                  : date === today && "bg-[#FFFFFF50]"
              } flex h-[44px] w-[44px] items-center justify-center rounded-full text-center`}
            >
              {format(date, "d")}
            </p>
            {type === "RECORD_COMPLETE" ? (
              // Check if backend returns detailed data
              (mealDates?.length > 0 || otherRecordDates?.length > 0) ? (
                // Show two dots - NEW BEHAVIOR
                (mealDates?.includes(date) || otherRecordDates?.includes(date)) && (
                  <div className="flex gap-[2px] justify-center -mt-[10px]">
                    {mealDates?.includes(date) && (
                      <p className={`h-[5px] w-[5px] rounded-full ${date === chosenDate ? 'bg-[#417FFF]' : 'bg-[#B0CAFE]'}`} />
                    )}
                    {otherRecordDates?.includes(date) && (
                      <p className={`h-[5px] w-[5px] rounded-full ${date === chosenDate ? 'bg-[#FE718E]' : 'bg-[#FFDBE4]'}`} />
                    )}
                  </div>
                )
              ) : (
                // Fallback: single blue dot for all records
                existDates?.includes(date) && (
                  <div className="flex gap-[2px] justify-center -mt-[10px]">
                    <p className={`h-[5px] w-[5px] rounded-full ${date === chosenDate ? 'bg-[#417FFF]' : 'bg-[#B0CAFE]'}`} />
                  </div>
                )
              )
            ) : (
              // Other pages: single colored dot
              existDates?.includes(date) && (
                <div className="flex gap-[2px] justify-center -mt-[10px]">
                  <p className={`h-[5px] w-[5px] rounded-full ${
                    date === chosenDate
                      ? `${typeChecker[type]?.bg}`
                      : `${typeChecker[type]?.dot}`
                  }`} />
                </div>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
export default DateStrip;
